import React, { useState, useEffect, useContext } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { AppContext, DromoUploader, getTranslatedText } from '@nile/components';
import Loader from '@nile/mangifera/src/Components/Ticket/TicketCount';
import { getTicketWorklogsImportFields } from '../Fields/ticketWorklogsFields';
import { intlConverter } from '../utils/helpers';
import { ImportIdentifier } from '../constants';
const TicketWorklogsUploader = (props) => {
  const { userToken, activator, onResults, onCancel } = props;
  const intl = useIntl();

  const appContext = useContext(AppContext);
  const { currentProduct } = appContext;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setLoading(true);
    const ticketWorklogsImportFields = getTicketWorklogsImportFields(
      currentProduct
    );
    const initFields = [...ticketWorklogsImportFields];

    const selectFields = ticketWorklogsImportFields.reduce(
      (acc, field, idx) => {
        if (field.type === 'select') acc[idx] = field.selectOptions;
        return acc;
      },
      {}
    );

    const promises = Object.values(selectFields);
    Promise.all(promises)
      .then((options) => {
        options.forEach((set, idx) => {
          const indexToModify = Object.keys(selectFields)[idx];
          initFields[indexToModify].selectOptions = set;
        });
        setFields([...intlConverter(intl, initFields)]);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        console.log(e);
      });
  }, []);

  const handleRowHooks = ({ row, index }) => {
    const newRecord = { row, index };

    const validationFieldsArray = ['startTime', 'endTime'];

    validationFieldsArray.forEach((key) => {
      newRecord.row[key].info = [];
    });

    function addError(key, errorKey) {
      newRecord.row[key].info = [
        {
          message: getTranslatedText(
            intl,
            errorKey || 'dromo.validation.requiredField'
          ),
          level: 'error'
        }
      ];
    }

    // checking the start time and end time are within 24 hours
    let startTime = newRecord.row.startTime.resultValue;
    let endTime = newRecord.row.endTime.resultValue;
    if (startTime && endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);

      if (start > end) {
        addError('endTime', 'dromo.validation.endTimeBeforeStartTime');
      }
      const diffInMs = end - start;

      if (diffInMs < 60000) {
        addError('endTime', 'dromo.validation.timeDifferenceTooSmall');
      }

      const diffInHours = diffInMs / (1000 * 60 * 60);

      if (diffInHours > 24) {
        addError('endTime', 'dromo.validation.endTimeExceeds24Hours');
      }
    }

    return newRecord;
  };

  if (loading) return <Loader loading />;

  if (error) return null;

  return (
    <DromoUploader
      settings={{
        importIdentifier: ImportIdentifier.TICKET_WORKLOGS,
        title: getTranslatedText(intl, 'migrate.data.ticketWorklogs.title')
      }}
      fields={fields}
      rowHooks={[(row) => row, handleRowHooks]}
      columnHooks={[(column) => column]}
      onResults={(response, metadata) => {
        if (onResults) onResults();
      }}
      onCancel={() => {
        if (onCancel) onCancel();
      }}
      activator={
        activator || (
          <div className="flex center actionListItemPadding ptr">
            <div className="mr-10 flex center">
              <SVGIcon name="TicketWorklogs" />
            </div>
            <FormattedMessage id="migrate.data.ticketWorklogs.title" />
          </div>
        )
      }
      userToken={userToken}
      backendSync
    />
  );
};

export default TicketWorklogsUploader;
